import {VerificationnoteResource} from '@services/resource/verificationnote-resource';

export class VerificationResource {
  constructor(
    public readonly product: VerificationnoteResource[],
    public readonly startup: VerificationnoteResource[],
  ) {}
}
